/**
 * Custom Chat Widget Integration
 * Handles opening the chat widget for buttons with data-chat-widget attribute
 * Also manages widget visibility on mobile screens near footer
 */

class CustomGorgiasChat {
  constructor() {
    this.isHidden = false;
    this.scrollThreshold = 100;
    this.mobileBreakpoint = 749;
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupWidget());
    } else {
      this.setupWidget();
    }
  }

  setupWidget() {
    this.bindEvents();
    this.bindScrollListener();
  }

  bindEvents() {
    const chatButtons = document.querySelectorAll('[data-chat-widget="true"]');

    chatButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.openChat();
      });
    });
  }

  bindScrollListener() {
    let ticking = false;
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  handleScroll() {
    // Only run on screens 749px and smaller
    if (window.innerWidth > this.mobileBreakpoint) {
      if (this.isHidden) {
        this.showWidget();
      }
      return;
    }

    const footer = document.querySelector('.footer-utilities__group-copyright');
    if (!footer) return;

    const footerRect = footer.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // Check if user is within 100px of the footer
    const distanceToFooter = footerRect.top - windowHeight;
    const shouldHide = distanceToFooter <= this.scrollThreshold;

    if (shouldHide && !this.isHidden) {
      this.hideWidget();
    } else if (!shouldHide && this.isHidden) {
      this.showWidget();
    }
  }

  hideWidget() {
    const iframes = this.getGorgiasIframes();
    iframes.forEach(iframe => {
      if (iframe) {
        iframe.style.display = 'none';
      }
    });
    this.isHidden = true;
  }

  showWidget() {
    const iframes = this.getGorgiasIframes();
    iframes.forEach(iframe => {
      if (iframe) {
        iframe.style.display = '';
      }
    });
    this.isHidden = false;
  }

  getGorgiasIframes() {
    return [
      document.querySelector('#chat-window'),
      document.querySelector('iframe[src*="gorgias"]'),
      document.querySelector('[id*="gorgias"]')
    ].filter(Boolean);
  }

  openChat() {
    if (window.GorgiasChat) {
      window.GorgiasChat.open();
    } else {
      console.error('Gorgias chat widget not available');
    }
  }
}

new CustomGorgiasChat();
